export default {
  title: "Lieu",
  capacity: "Capacité",
  form: {
    capacity: "Capacité maximale",
    capacityPlaceholder: "Nombre maximum de places",
    errors: {
      capacityPositive: "La capacité doit être un nombre positif"
    }
  }
};

